import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Toast } from 'models/toasts';
import iconError from 'assets/images/icon_error.svg';

type PropsType = {
  toast: Toast;
};

const ServerErrorToast: React.FunctionComponent<PropsType> = ({ toast }) => {
  const { t } = useTranslation('toast');

  return (
    <React.Fragment>
      <ServerErrorToastHeader>
        <IconError />
        <Strong className="mr-auto">
          {toast.content.title ? toast.content.title : t('validationError')}
        </Strong>
      </ServerErrorToastHeader>
      <InfoToastBody className="toast-body">
        {toast.content.message}
      </InfoToastBody>
    </React.Fragment>
  );
};
const Strong = styled.strong`
  color: #ffffff;
`;
const InfoToastBody = styled.div`
  color: #000000;
  white-space: pre-line;
`;
const ServerErrorToastHeader = styled.div`
  display: flex;
  align-items: center;
  height: 37px;
  padding: 0.25rem 0.75rem;
  color: #ffffff;
  background-color: rgba(196, 33, 33, 0.68);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;
const IconError = styled.div`
  width: 23.157px;
  height: 20.444px;
  margin-right: 8px;
  background-image: url(${iconError});
`;
export default ServerErrorToast;
